import { getRouteApi } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/AppShell";
import { EmptyState } from "@/components/EmptyState";
import { useProject } from "@/lib/store";
import { ProjectLoading, useLoadProject } from "./ProjectHome";

const route = getRouteApi("/$ws/project/$key/$section");

/** Docs / Tasks / Milestone land in Phases 3–4; until then a labelled placeholder. */
export function ProjectPlaceholderPage() {
  const { t } = useTranslation();
  const { ws, key, section } = route.useParams();
  useLoadProject(ws, key);
  const d = useProject(ws, key);
  if (!d) return <ProjectLoading ws={ws} kkey={key} />;
  const label = t(`nav.${section === "milestones" ? "milestone" : section}`, { defaultValue: section });
  return (
    <>
      <PageHeader crumbs={[d.project.name, label]} />
      <div className="flex flex-1 items-center justify-center">
        <EmptyState title={t("project.comingSoonSection", { section: label })} body={t("project.comingSoonBody")} />
      </div>
    </>
  );
}
